import React, { useRef } from 'react'
import { Route, Redirect, Switch, useRouteMatch, useHistory } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import IdleTimer from 'react-idle-timer'
import PageNotFound from 'shared/components/PageNotFound.jsx'
import PrivateRoute from './PrivateRoute'
import PrivacyNotice from '../PrivacyNotice/index'
import ScreeningQuestion from '../ScreeningQuestion/index'
import ScreeningQuestionNo from '../ScreeningQuestionNo/index'
import ScreeningQuestionNotSure from '../ScreeningQuestionNotSure/index'
import AddressTypeChange from '../AddressTypeChange/index'
import PersonalInformation from '../PersonalInformation/index'
import CurrentAddress from '../CurrentAddress/index'
import JointlyOwnedVehicleInformation from '../JointlyOwnedVehicleInformation/index'
import BusinessVehicleInformation from '../BusinessVehicleInformation/index'
import ContactInformation from '../ContactInformation/index'
import NewAddressEffective from '../NewAddressEffective/index'
import Layout from 'containers/Layout/topbar/index.jsx'
import Footer from 'containers/Layout/footer/footer.jsx'
import HouseholdList from '../HouseholdList/index'
import AddressesToChange from '../AddressesToChange'
import NewAddress from '../NewAddress';
import ReviewSummary from '../ReviewSummary'
import JointlyOwnedVehicleSummary from '../JointlyOwnedVehicleInformation/components/summary'
import BusinessVehicleSummary from '../BusinessVehicleInformation/components/summary'
import ReceiveConfirmation from "../ReceiveConfirmation";
import Confirmation from '../Confirmation';

const ChangeOfAddressRoutes = ({ t, i18n }) => {
  const match = useRouteMatch()
  const history = useHistory()
  const idleMinutes = process.env.REACT_APP_IDLE_TIMEOUNT_MINUTES

  const idleEl = useRef(null)

  const onIdle = () => {
    history.push(`${match.path}${t('routes.privacy_notice')}`)
  }

  return (
    <React.Fragment>
      <IdleTimer ref={idleEl} element={document} onIdle={onIdle} debounce={250} timeout={1000 * 60 * parseFloat(idleMinutes)} />
      <Layout />
      <Switch>
        <Route path={`${match.path}${t('routes.not_found')}`} component={PageNotFound} />
        {/*
        <Route path={`${match.path}${t('routes.confirmation')}`} component={Confirmation} />
        <PrivateRoute path={`${match.path}${t('routes.review_confirmation')}`} component={ReviewConfirmation} />*/}
        <Route path={`${match.path}${t('routes.confirmation')}`} component={Confirmation} />
        <PrivateRoute path={`${match.path}${t('routes.receive_confirmation')}/:transId/:transOwner`} component={ReceiveConfirmation} />
        <PrivateRoute path={`${match.path}${t('routes.new_address_effective')}`} component={NewAddressEffective} />
        <PrivateRoute path={`${match.path}${t('routes.new_address')}`} component={NewAddress} />
        <PrivateRoute path={`${match.path}${t('routes.contact_info')}`} component={ContactInformation} />

        <PrivateRoute path={`${match.path}${t('routes.current_address')}`} component={CurrentAddress} />
        <PrivateRoute path={`${match.path}${t('routes.screening_question_not_sure')}`} component={ScreeningQuestionNotSure} />
        <PrivateRoute path={`${match.path}${t('routes.screening_question_no')}`} component={ScreeningQuestionNo} />

        <PrivateRoute path={`${match.path}${t('routes.business_vehicle_info')}`} component={BusinessVehicleInformation} />
        <PrivateRoute path={`${match.path}${t('routes.business_vehicle_info_summary')}`} component={BusinessVehicleSummary} />

        <PrivateRoute path={`${match.path}${t('routes.jointly_owned_vehicle_info')}`} component={JointlyOwnedVehicleInformation} />
        <PrivateRoute path={`${match.path}${t('routes.jointly_owned_summary')}`} component={JointlyOwnedVehicleSummary} />

        <PrivateRoute path={`${match.path}${t('routes.personal_info')}`} component={PersonalInformation} />
        <PrivateRoute path={`${match.path}${t('routes.address_type_change')}`} component={AddressTypeChange} />
        <PrivateRoute path={`${match.path}${t('routes.screening_question')}`} component={ScreeningQuestion} />
        <PrivateRoute path={`${match.path}${t('routes.household_list')}`} component={HouseholdList} />
        <PrivateRoute path={`${match.path}${t('routes.addresses_to_change')}`} component={AddressesToChange} />

        <PrivateRoute path={`${match.path}${t('routes.review_summary')}`} component={ReviewSummary} />
        <Route path={`${match.path}${t('routes.privacy_notice')}`} component={PrivacyNotice} />
        <Redirect from={`/${i18n.language}/*`} to={`${match.path}${t('routes.not_found')}`} />
        <Redirect exact from={`${match.path}`} to={`${match.path}${t('routes.privacy_notice')}`} />
      </Switch>
      <Footer />
    </React.Fragment>
  )
}

export default withTranslation('common')(ChangeOfAddressRoutes)
